import { render, staticRenderFns } from "./CardItem.vue?vue&type=template&id=d019d3ee&"
import script from "./CardItem.vue?vue&type=script&lang=ts&"
export * from "./CardItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports